export class VerifyModel 
{
    Token: string;
    Password: string;
}